<template>
    <section>
        <v-toolbar color="primary" dark class="v-toolbar-header">
            <v-toolbar-title aling="center">
                <v-icon>mdi-home</v-icon> Solicitudes / Requerimientos
            </v-toolbar-title>
        </v-toolbar>
        <v-card flat>
            <v-container fluid>
                <PlusMenu :menuItems="menuItems" icon="mdi-cube-outline" />
                <v-row>
                    <v-col cols="12" sm="6" md="1" class="custom-card-col">
                        <v-card class="mx-auto" color="primary" dark>
                            <v-card-text>
                                <div class="card-title">Solicitadas</div>
                                <div class="card-number">
                                    {{ itemsSolicitados.length }}
                                </div>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn icon>
                                    <v-icon @click="exportExcel('SOLICITADO')"
                                        >mdi-file-excel-box</v-icon
                                    >
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn icon>
                                    <v-icon
                                        @click="viewItems('itemsSolicitados')"
                                        >mdi-arrow-right</v-icon
                                    >
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>

                    <v-col cols="12" sm="6" md="1" class="custom-card-col">
                        <v-card class="mx-auto" color="info" dark>
                            <v-card-text>
                                <div class="card-title">Autorizadas</div>
                                <div class="card-number">
                                    {{ itemsAutorizados.length }}
                                </div>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn icon>
                                    <v-icon @click="exportExcel('AUTORIZADO')"
                                        >mdi-file-excel-box</v-icon
                                    >
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn icon>
                                    <v-icon
                                        @click="viewItems('itemsAutorizados')"
                                        >mdi-arrow-right</v-icon
                                    >
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>

                    <v-col cols="12" sm="6" md="1" class="custom-card-col">
                        <v-card class="mx-auto" color="warning" dark>
                            <v-card-text>
                                <div class="card-title">Por Comprar</div>
                                <div class="card-number">
                                    {{ itemsEnCompra.length }}
                                </div>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn icon>
                                    <v-icon
                                        @click="
                                            exportExcel('EN PROCESO DE COMPRA')
                                        "
                                        >mdi-file-excel-box</v-icon
                                    >
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn icon>
                                    <v-icon @click="viewItems('itemsEnCompra')"
                                        >mdi-arrow-right</v-icon
                                    >
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>

                    <v-col cols="12" sm="6" md="1" class="custom-card-col">
                        <v-card class="mx-auto" color="accent" dark>
                            <v-card-text>
                                <div class="card-title">Por Entregar</div>
                                <div class="card-number">
                                    {{ itemsPorEntrega.length }}
                                </div>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn icon>
                                    <v-icon @click="exportExcel('RECIBIDO')"
                                        >mdi-file-excel-box</v-icon
                                    >
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn icon>
                                    <v-icon
                                        @click="viewItems('itemsPorEntrega')"
                                        >mdi-arrow-right</v-icon
                                    >
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>

                    <v-col cols="12" sm="6" md="1" class="custom-card-col">
                        <v-card class="mx-auto" color="secondary" dark>
                            <v-card-text>
                                <div class="card-title">Despachadas</div>
                                <div class="card-number">
                                    {{ itemsDespachados.length }}
                                </div>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn icon>
                                    <v-icon @click="exportExcel('DESPACHADO')"
                                        >mdi-file-excel-box</v-icon
                                    >
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn icon>
                                    <v-icon
                                        @click="viewItems('itemsDespachados')"
                                        >mdi-arrow-right</v-icon
                                    >
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>

                    <v-col cols="12" sm="6" md="1" class="custom-card-col">
                        <v-card class="mx-auto" color="success" dark>
                            <v-card-text>
                                <div class="card-title">Recepcionadas</div>
                                <div class="card-number">
                                    {{ itemsRecepcionados.length }}
                                </div>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn icon>
                                    <v-icon @click="exportExcel('RECEPCIONADO')"
                                        >mdi-file-excel-box</v-icon
                                    >
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn icon>
                                    <v-icon
                                        @click="viewItems('itemsRecepcionados')"
                                        >mdi-arrow-right</v-icon
                                    >
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>

                    <v-col cols="12" sm="6" md="1" class="custom-card-col">
                        <v-card class="mx-auto" color="error" dark>
                            <v-card-text>
                                <div class="card-title">Rechazadas</div>
                                <div class="card-number">
                                    {{ itemsRechazados.length }}
                                </div>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn icon>
                                    <v-icon @click="exportExcel('RECHAZADO')"
                                        >mdi-file-excel-box</v-icon
                                    >
                                </v-btn>
                                <v-spacer></v-spacer>
                                <v-btn icon>
                                    <v-icon
                                        @click="viewItems('itemsRechazados')"
                                        >mdi-arrow-right</v-icon
                                    >
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>

            <v-card-text>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                    class="mb-4"
                ></v-text-field>
                <v-data-table
                    :headers="headers"
                    :items="movements"
                    :search="search"
                    class="elevation-1 custom-font"
                >
                    <template v-slot:[`item.estado`]="{ item }">
                        <v-chip :color="getColor(item.estado)" dark>
                            {{ item.estado }}
                        </v-chip>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-icon small class="mr-2" @click="viewRequest(item)">
                            mdi-eye
                        </v-icon>
                    </template>
                    <template v-slot:no-data>
                        Favor seleccione las solicitudes
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
        <v-dialog v-model="gestRequest" :key="keyStock">
            <request v-on="{ closeModal }" />
        </v-dialog>
        <v-dialog
            v-model="gestRequestSets"
            :key="keySets"
            class="kits-agregate"
        >
            <requestSets v-on="{ closeModal }" />
        </v-dialog>
        <v-dialog
            v-model="gestRequestKits"
            :key="keyKits"
            class="kits-agregate"
        >
            <requestKits v-on="{ closeModal }" />
        </v-dialog>
        <v-dialog v-model="gestRequestView" max-width="1000px" :key="keyView">
            <requestView
                :request="requestView"
                v-on="{ closeModal }"
                :quoteRequest="quoteRequest"
                :purchaseOrder="purchaseOrder"
                :purchase="purchase"
                :statusRequest="statusRequest"
            />
        </v-dialog>
    </section>
</template>

<script>
import UserProfile from "../data";
import PlusMenu from "../components/plusMenu.vue";
import { getRequestByStatus, getRequests, xlsRequestStatus } from "../dataApi";
import request from "../components/request.vue";
import requestKits from "../components/requestKits.vue";
import requestSets from "../components/requestSets.vue";
import requestView from "../components/requestView.vue";
export default {
    components: {
        PlusMenu,
        request,
        requestKits,
        requestView,
        requestSets,
    },
    data: () => ({
        user: UserProfile.getUserData(),
        search: "",
        headers: [
            { text: "Referencia", value: "ref" },
            { text: "Estado", value: "status" },
            { text: "Solicitante", value: "user.fullName" },
            { text: "Fecha", value: "requestDate" },
            { text: "Centro de Costo", value: "costCenter" },
            { text: "Acciones", value: "actions" },
        ],
        keyStock: 100,
        keyKits: 200,
        keySets: 300,
        movements: [],
        kitsItems: [],
        menuItems: [],
        itemsSolicitados: [],
        itemsAutorizados: [],
        itemsEnCompra: [],
        itemsDespachados: [],
        itemsRechazados: [],
        itemsPorEntrega: [],
        itemsRecepcionados: [],
        itemsTotal: [],
        gestRequest: false,
        gestRequestKits: false,
        gestRequestSets: false,
        products: [],
        employees: [],
        gestRequestView: false,
        keyView: 0,
        requestView: null,
        pendientes: 0,
        procesadas: 0,
        total: 0,
        quoteRequest: false,
        purchaseOrder: false,
        purchase: false,
        statusRequest: "",
        itemsViewActive: "itemsSolicitados",
    }),
    async mounted() {
        setTimeout(() => {
            this.getRequests();
        }, 200);
    },
    created() {
        this.menuItems = [
            {
                title: "Generar Solicitud Individual",
                icon: "mdi-open-in-new",
                action: this.viewStock,
                roles: `admin,rrhh,sup,user`,
            },
            {
                title: "Generar Solicitud Masiva",
                icon: "mdi-cube-unfolded",
                action: this.viewSets,
                roles: `admin,rrhh,sup,user`,
            },
        ];
    },
    methods: {
        async getRequests() {
            this.itemsTotal = await getRequests();
            this.itemsSolicitados = await getRequestByStatus(
                ["SOLICITADO"],
                this.itemsTotal,
            );
            this.itemsAutorizados = await getRequestByStatus(
                ["AUTORIZADO", "INDIVIDUAL"],
                this.itemsTotal,
            );
            this.itemsRechazados = await getRequestByStatus(
                ["RECHAZADO"],
                this.itemsTotal,
            );
            this.itemsEnCompra = await getRequestByStatus(
                ["EN PROCESO DE COMPRA"],
                this.itemsTotal,
            );
            this.itemsDespachados = await getRequestByStatus(
                ["ENTREGADO", "DESPACHADO"],
                this.itemsTotal,
            );
            this.itemsPorEntrega = await getRequestByStatus(
                ["RECIBIDO"],
                this.itemsTotal,
            );
            this.itemsRecepcionados = await getRequestByStatus(
                ["RECEPCIONADO"],
                this.itemsTotal,
            );
            //this.updateCounts();
            this.viewItems();
            //console.log(this.itemsPendientes);
        },

        viewStock() {
            this.keyStock++;
            this.gestRequest = true;
        },

        viewKits() {
            this.keyKits++;
            this.gestRequestKits = true;
        },

        viewSets() {
            this.keySets++;
            this.gestRequestSets = true;
        },

        closeModal() {
            this.gestRequest = false;
            this.gestRequestKits = false;
            this.gestRequestSets = false;
            this.gestRequestView = false;
            this.keyStock++;
            this.keyKits++;
            this.keySets++;
            this.keyView++;
            this.getRequests();
        },

        viewRequest(request) {
            console.log("viewRequest", request);
            this.quoteRequest = request.quoteRequest;
            this.purchaseOrder = request.purchaseOrder;
            this.purchase = request.purchase;
            this.requestView = request.id;
            this.statusRequest = request.status;
            this.keyView++;
            this.gestRequestView = true;
        },

        updateCounts() {
            this.pendientes = this.itemsPendientes.length;
            this.procesadas = this.itemsProcesadas.length;
            this.total = this.pendientes + this.procesadas;
        },

        viewItems(typesRequests = undefined) {
            if (typesRequests) this.itemsViewActive = typesRequests;
            const typesMap = {
                itemsSolicitados: this.itemsSolicitados,
                itemsAutorizados: this.itemsAutorizados,
                itemsEnCompra: this.itemsEnCompra,
                itemsDespachados: this.itemsDespachados,
                itemsRechazados: this.itemsRechazados,
                itemsPorEntrega: this.itemsPorEntrega,
                itemsRecibidos: this.itemsRecibidos,
                itemsRecepcionados: this.itemsRecepcionados,
            };
            this.movements =
                typesMap[this.itemsViewActive] || this.itemsSolicitados;
        },

        exportExcel(status) {
            xlsRequestStatus(status);
        },
    },
    computed: {
        isAdmin() {
            return this.user.level == "admin" || this.user.level == "sys";
        },
    },
};
</script>
<style scoped>
.kits-agregate {
    max-width: 90vw;
}

.custom-card-col {
    flex: 0 0 calc(100% / 7);
    /* Calcula el ancho para 7 columnas */
    max-width: calc(100% / 7);
    /* Evita que se estiren demasiado */
    display: flex;
    margin-bottom: 10px;
}

.card-title {
    font-size: clamp(0.8rem, 2vw, 1.25rem);
    font-weight: 500;
    margin-bottom: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.card-number {
    font-size: clamp(1.4rem, 4vw, 2.8rem);
    font-weight: bold;
    line-height: 1.2;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
    padding: 4px 0;
}

/* Make cards take full width of their column */
.v-card {
    width: 100%;
    display: flex;
    flex-direction: column;
}

.v-card-text {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 12px;
}

/* Responsive adjustments for different screen sizes */
@media (max-width: 600px) {
    .v-card-text {
        padding: 8px;
    }

    .v-card-actions {
        padding: 4px;
    }
}
</style>
